module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/ant-portuguese.b547e529.jpg";